import { Button } from 'flowbite-react';
import React, { useEffect } from 'react';
import Select, { SingleValue } from 'react-select';
import { Dropdown } from 'shared-utils';
import { useUserContext } from 'src/context/UserProvider';
import { RoundLabelType, SingleRoundLabel, UserRole } from 'types';
interface Props {
	numberOfRounds: number;
	value: SingleRoundLabel[];
	onChange: (val: SingleRoundLabel[]) => void;
}

const SelectRoundType = ({ numberOfRounds, onChange, value }: Props) => {
	const [showRoundLabel, setShowRoundLabel] = React.useState(false);
	const { user } = useUserContext();
	// create a number array from 1 to numberOfRounds
	const roundNumbers = Array.from({ length: numberOfRounds }).map((_, index) => index + 1);
	useEffect(() => {
		// if value array contains a round number that is greater than the number of rounds, remove it
		if (value.some(roundLabel => roundLabel.order > numberOfRounds)) {
			const updatedValue = value.filter(roundLabel => roundLabel.order <= numberOfRounds);
			onChange(updatedValue);
		}
	}, [numberOfRounds, onChange, value]);

	if ([UserRole.RECRUITER].includes(user?.role as UserRole)) {
		return null;
	}

	return (
		<div className="my-[16px]">
			<div className="flex items-center gap-[8px]">
				<Button
					size={'sm'}
					onClick={() => {
						setShowRoundLabel(!showRoundLabel);
					}}
					color="purplePlaced"
				>
					Add Round Labels
				</Button>
				<p className="text-[12px] text-[red]">(Click to add specific round type/label for a particular round number)</p>
			</div>

			{showRoundLabel && (
				<div className="grid gap-[16px] mt-[16px]">
					{roundNumbers.map((roundNumber, index) => (
						<div key={index} className="flex gap-[16px] items-center">
							<p className="text-[14px] text-gray-600">Select Round {index + 1} Label:</p>
							<Select
								menuPlacement={'auto'}
								classNamePrefix="my-select-plans"
								options={
									Object.values(RoundLabelType).map((label, i) => ({
										label,
										value: label,
									})) as Dropdown[]
								}
								onChange={(val: SingleValue<Dropdown>) => {
									const selectedValue = val as Dropdown;
									const updatedValue = value.filter((roundLabel, i) => roundLabel.order !== roundNumber);
									updatedValue.push({ order: roundNumber as number, type: selectedValue.value as RoundLabelType });
									onChange(updatedValue);
								}}
								placeholder="Select Round Label"
								value={
									value.find(roundLabel => roundLabel.order === roundNumber)
										? {
												label: value.find(roundLabel => roundLabel.order === roundNumber)?.type as RoundLabelType,
												value: value.find(roundLabel => roundLabel.order === roundNumber)?.type as RoundLabelType,
										  }
										: null
								}
							/>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default SelectRoundType;
